import { AccountController } from "@/app/ui/controllers/AccountController";

const accountIsNonForeign = !AccountController.accountData.accountIsForeign;

interface ProductAsset {
  [key: string]: {
    imageActive: string;
    imageInactive: string;
    colorActive: string;
    colorInactive: string;
    label: string;
  };
}

export const productStyle: ProductAsset = {
  BOSSPACK: {
    imageActive: "bosspack-active",
    imageInactive: "bosspack-inactive",
    colorActive: "#8E78DB",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Prioritas" : "Priority",
  },
  REGPACK: {
    imageActive: "regpack-active",
    imageInactive: "regpack-inactive",
    colorActive: "#4FB0EC",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Reguler" : "Regular",
  },
  MINIPACK: {
    imageActive: "minipack-active",
    imageInactive: "minipack-inactive",
    colorActive: "#FFD900",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Paket Ringan" : "Lightweight Package"
  },
  JAGOPACK: {
    imageActive: "jagopack-active",
    imageInactive: "jagopack-inactive",
    colorActive: "#00B155",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Ekonomis" : "Economical",
  },
  BIGPACK: {
    imageActive: "bigpack-active",
    imageInactive: "bigpack-inactive",
    colorActive: "#ED6140",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Paket Berat" : "Big Package",
  },
  BIGPACKFAST: {
    imageActive: "bigpackfast-active",
    imageInactive: "bigpackfast-inactive",
    colorActive: "#ED6140",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Paket Berat & Cepat" : "Big Package & Fast",
  },
  JUMBOPACK: {
    imageActive: "jumbopack-active",
    imageInactive: "jumbopack-inactive",
    colorActive: "#ED6140",
    colorInactive: "#999999",
    label: "Paket jumbo",
  },
  INTERPACK: {
    imageActive: "interpack-active",
    imageInactive: "interpack-inactive",
    colorActive: "#FF7B9C",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Internasional" : "International",
  },
  INTERPACKMAXI: {
    imageActive: "interpackmaxi-active",
    imageInactive: "interpackmaxi-inactive",
    colorActive: "#FF7B9C",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "Internasional Bulk" : "International & Fast",
  },
  OTOPACK150: {
    imageActive: "otopack150-active",
    imageInactive: "otopack150-inactive",
    colorActive: "#FFA900",
    colorInactive: "#999999",
    label: "Motor 150cc",
  },
  OTOPACK250: {
    imageActive: "otopack250-active",
    imageInactive: "otopack250-inactive",
    colorActive: "#FFA900",
    colorInactive: "#999999",
    label: "Motor 250cc",
  },
  ONEPACK: {
    imageActive: "onepack-active",
    imageInactive: "onepack-inactive",
    colorActive: "#BC9AFD",
    colorInactive: "#999999",
    label: "Express",
  },
  VIPPACK: {
    imageActive: "vippack-active",
    imageInactive: "vippack-inactive",
    colorActive: "#333333",
    colorInactive: "#999999",
    label: accountIsNonForeign ? "VIP antarkota & pulau" : "Intercity & Island VIP",
  },
  SAMEDAY: {
    imageActive: "sameday-active",
    imageInactive: "sameday-inactive",
    colorActive: "#FFDD5A14",
    colorInactive: "#999999",
    label: "SAME DAY",
  },
};
